var BrandfolderHexColors;
(function (BrandfolderHexColors) {
  BrandfolderHexColors["AquaKnockoff"] = '#00b0f7';
  BrandfolderHexColors["Black"] = '#000000';
  BrandfolderHexColors["BlueberryDelight"] = '#1d3163';
  BrandfolderHexColors["Delete"] = '#D0021B';
  BrandfolderHexColors["DirtyMarshmallow"] = '#F1F5FA';
  BrandfolderHexColors["DirtyMarshmallowHalf"] = '#f8fafc';
  BrandfolderHexColors["Gray"] = '#E6E6E6';
  BrandfolderHexColors["GrayBorder"] = '#CECECE';
  BrandfolderHexColors["GrayDark"] = '#6F6F6F';
  BrandfolderHexColors["GrayMedium"] = '#CBCBCB';
  BrandfolderHexColors["GrayMediumDark"] = '#9B9B9B';
  BrandfolderHexColors["Marshmallow"] = '#F9FBFC';
  BrandfolderHexColors["OrangeLight"] = '#FFE4B3';
  BrandfolderHexColors["PurplePopsicle"] = '#4462c9';
  BrandfolderHexColors["Text"] = '#4A4A4A';
  BrandfolderHexColors["Title"] = '#333333';
  BrandfolderHexColors["WarningRed"] = '#F64E63';
  BrandfolderHexColors["White"] = '#FFFFFF';
})(BrandfolderHexColors || (BrandfolderHexColors = {}));
var Colors;
(function (Colors) {
  Colors[
  // intentionally first
  "None"] = '';
  Colors["Danger"] = 'danger';
  Colors["Primary"] = 'primary';
})(Colors || (Colors = {}));
export { BrandfolderHexColors, Colors };